import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Row, Col, Form } from "react-bootstrap";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import _ from "lodash";

import classes from "../../maintainers.module.scss";
import { customStyles } from "../products.constants";
import { decimalValidateNew, formatMilesDecimalNew, integerValidate } from "@/services/Utils";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

const units_measurement = [
	{ value: "u", label: "Un" },
	{ value: "g", label: "g" },
	{ value: "cc", label: "cc" },
];

const TabFields = ({ data, setData }) => {
	const { categories, countries, aptitudes, dealers, chemicals, crops, pests } = useSelector((state) => state.maintainers_products);

	const [localCategories, setLocalCategories] = useState([]);
	const [localAptitudes, setLocalAptitudes] = useState([]);
	const [localChemicals, setLocalChemicals] = useState([]);
	const [localCrops, setLocalCrops] = useState([]);
	const [localPests, setLocalPests] = useState([]);

	useEffect(() => {
		setLocalCategories(categories);
		setLocalAptitudes(aptitudes);
		setLocalChemicals(chemicals);
		setLocalCrops(crops);
		setLocalPests(pests);
		// eslint-disable-next-line
	}, []);

	return (
		<Row className={classes.row_form} style={{ marginTop: "10px" }}>
			<Col md={6} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Código SAG</Form.Label>
					<Form.Control value={data.code_sag ? data.code_sag : ""} readOnly type="text" />
				</Form.Group>
			</Col>

			<Col md={6} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Nombre</Form.Label>
					<Form.Control
						value={data.name ? data.name : ""}
						onChange={(e) =>
							setData({
								...data,
								name: e.currentTarget.value,
							})
						}
						type="text"
					/>
				</Form.Group>
			</Col>

			<Col md={6} xs={12}>
				<Row>
					<Col md={12}>
						<Form.Group className={classes.group_form}>
							<Form.Label className={classes.label}>Ud. de Medida</Form.Label>
							<Select
								value={units_measurement && units_measurement.filter((c) => c.value === data.unit_measurement)}
								placeholder={<div>Seleccione</div>}
								options={units_measurement ? units_measurement : []}
								onChange={(value) =>
									setData({
										...data,
										unit_measurement: value ? value.value : "",
									})
								}
								components={{
									NoOptionsMessage,
								}}
								isClearable
							/>
						</Form.Group>
					</Col>
				</Row>
			</Col>

			<Col md={6} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Categoría</Form.Label>
					<CreatableSelect
						value={
							localCategories &&
							localCategories.filter(
								(a) => data.category_id && data.category_id.length > 0 && _.map(data.category_id.split(","), String).includes(String(a.value)),
							)
						}
						styles={customStyles}
						isMulti
						placeholder={<div>Seleccione</div>}
						options={localCategories ? localCategories : []}
						onChange={(opt, meta) => {
							if (meta.action === "create-option") {
								let newOption = {
									value: meta.option.value,
									label: meta.option.label,
								};
								setLocalCategories([...localCategories, newOption]);
							}

							let baseValue = [];
							opt.forEach((element) => {
								baseValue.push(element.value);
							});

							setData({
								...data,
								category_id: baseValue.length !== 0 ? baseValue.toString() : "",
							});
						}}
						components={{ NoOptionsMessage }}
						formatCreateLabel={(value) => {
							return `Crear ${value}`;
						}}
					/>
				</Form.Group>
			</Col>

			<Col md={6} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Aptitudes</Form.Label>
					<CreatableSelect
						value={
							localAptitudes &&
							localAptitudes.filter(
								(a) => data.aptitud_id && data.aptitud_id.length > 0 && _.map(data.aptitud_id.split(","), String).includes(String(a.value)),
							)
						}
						styles={customStyles}
						isMulti
						placeholder={<div>Seleccione</div>}
						options={localAptitudes ? localAptitudes : []}
						onChange={(opt, meta) => {
							if (meta.action === "create-option") {
								let newOption = {
									value: meta.option.value,
									label: meta.option.label,
								};
								setLocalAptitudes([...localAptitudes, newOption]);
							}

							let baseValue = [];
							opt.forEach((element) => {
								baseValue.push(element.value);
							});

							setData({
								...data,
								aptitud_id: baseValue.length !== 0 ? baseValue.toString() : "",
							});
						}}
						components={{ NoOptionsMessage }}
						formatCreateLabel={(value) => {
							return `Crear ${value}`;
						}}
					/>
				</Form.Group>
			</Col>

			<Col md={6} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Distribuidor</Form.Label>
					<Select
						value={dealers && dealers.filter((c) => Number(c.value) === Number(data.dealer_id))}
						placeholder={<div>Seleccione</div>}
						options={dealers ? dealers : []}
						onChange={(value) =>
							setData({
								...data,
								dealer_id: value ? value.value : "",
							})
						}
						components={{
							NoOptionsMessage,
						}}
						isClearable
					/>
				</Form.Group>
			</Col>

			<Col md={6} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Química</Form.Label>
					<CreatableSelect
						value={localChemicals && data.chemical_id ? localChemicals.find((a) => String(a.value) === String(data.chemical_id)) : null}
						styles={customStyles}
						placeholder={<div>Seleccione</div>}
						options={localChemicals ? localChemicals : []}
						onChange={(opt, meta) => {
							if (meta.action === "create-option") {
								let newOption = {
									value: meta.option.value,
									label: meta.option.label,
								};
								setLocalChemicals([...localChemicals, newOption]);
							}

							setData({
								...data,
								chemical_id: opt ? opt.value : "",
							});
						}}
						components={{ NoOptionsMessage }}
						formatCreateLabel={(value) => {
							return `Crear ${value}`;
						}}
						isClearable
					/>
				</Form.Group>
			</Col>

			<Col md={6} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Densidad</Form.Label>
					<Form.Control
						value={data.density ? formatMilesDecimalNew(data.density) : ""}
						onChange={(e) => {
							let newValue = String(e.currentTarget.value).replaceAll(".", "");
							setData({
								...data,
								density: newValue,
							});
						}}
						type="text"
						onKeyDown={decimalValidateNew}
					/>
				</Form.Group>
			</Col>

			<Col md={6} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Color Etiqueta</Form.Label>
					<Form.Control
						value={data.color_tag ? data.color_tag : ""}
						onChange={(e) =>
							setData({
								...data,
								color_tag: e.currentTarget.value,
							})
						}
						type="text"
					/>
				</Form.Group>
			</Col>

			<Col md={6} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>País</Form.Label>
					<Select
						value={countries && countries.filter((c) => Number(c.value) === Number(data.country_id))}
						placeholder={<div>Seleccione</div>}
						options={countries ? countries : []}
						onChange={(value) =>
							setData({
								...data,
								country_id: value ? value.value : "",
							})
						}
						components={{
							NoOptionsMessage,
						}}
						isClearable
					/>
				</Form.Group>
			</Col>

			<Col md={6} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Aplicaciones Máximas</Form.Label>
					<Form.Control
						value={data.max_applications ? data.max_applications : ""}
						onChange={(e) => {
							let newValue = String(e.currentTarget.value).replaceAll(".", "");
							setData({
								...data,
								max_applications: newValue,
							});
						}}
						type="text"
						onKeyDown={integerValidate}
					/>
				</Form.Group>
			</Col>

			<Col md={12} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Cultivo(s)</Form.Label>
					<CreatableSelect
						value={localCrops && data.crops ? localCrops.filter((crop) => data.crops.some((cropModel) => cropModel.value === crop.value)) : []}
						styles={customStyles}
						isMulti
						placeholder="Seleccione cultivo(s)"
						options={localCrops ? localCrops : []}
						onChange={(opt, meta) => {
							if (meta.action === "create-option") {
								const newOption = {
									value: meta.option.value,
									label: meta.option.label,
									pivot: {
										product_id: data.id,
										crop_id: meta.option.value,
									},
								};
								setLocalCrops([...localCrops, newOption]);
							}

							const updatedCrops = opt.map((selectedOption) => {
								const existingCrop = localCrops.find((crop) => crop.value === selectedOption.value);
								return existingCrop ? existingCrop : selectedOption;
							});

							setData({
								...data,
								crops: updatedCrops,
							});
						}}
						components={{ NoOptionsMessage }}
						formatCreateLabel={(value) => `Crear cultivo ${value}`}
					/>
				</Form.Group>
			</Col>

			<Col md={12} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Plaga(s)</Form.Label>
					<CreatableSelect
						value={localPests && data.pests ? localPests.filter((pest) => data.pests.some((pestModel) => pestModel.value === pest.value)) : []}
						styles={customStyles}
						isMulti
						placeholder={<>Seleccione plaga(s)</>}
						options={localPests ? localPests : []}
						onChange={(opt, meta) => {
							if (meta.action === "create-option") {
								const newOption = {
									value: meta.option.value,
									label: meta.option.label,
								};

								setLocalPests([...localPests, newOption]);
							}

							const updatePests = opt.map((selectedOption) => {
								const existingPest = localPests.find((pest) => pest.value === selectedOption.value);
								return existingPest ? existingPest : selectedOption;
							});

							setData({
								...data,
								pests: updatePests,
							});
						}}
						components={{ NoOptionsMessage }}
						formatCreateLabel={(value) => {
							return `Crear plaga ${value}`;
						}}
					/>
				</Form.Group>
			</Col>
		</Row>
	);
};

export default TabFields;
